import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Protege `login` de usuarios ya autenticados. Si ya hay sesión y venía un
 * `returnUrl` (p.ej. del deep-link de escaneo), lo respeta; si no, va a `home`.
 */
export const guestGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl');
  return router.parseUrl(returnUrl || '/home');
};
